import { I } from "./icons.jsx";

const NAV = [
  { section: "Workspace", num: "⌘1", items: [
    { route: "events",       icon: "cal",     label: "Events",       badge: "14" },
    { route: "sales",        icon: "trend",   label: "Sales",        badge: "live" },
    { route: "audience",     icon: "users",   label: "Audience",     badge: "12.4k" },
    { route: "inventory",    icon: "box",     label: "Inventory" },
    { route: "door",         icon: "scan",    label: "Door & Scan" },
  ]},
  { section: "Money", items: [
    { route: "payouts",      icon: "card",    label: "Payouts",      badge: "£4.2k" },
    { route: "fees",         icon: "splits",  label: "Fees & Splits" },
  ]},
  { section: "Network", items: [
    { route: "integrations", icon: "plug",    label: "Integrations", badge: "7" },
    { route: "distribution", icon: "globe",   label: "Distribution" },
    { route: "insights",     icon: "insight", label: "Insights" },
    { route: "settings",     icon: "cog",     label: "Settings" },
  ]},
];

export default function Rail({ route, onRoute }) {
  return (
    <aside className="rail">
      {NAV.map((s, i) => (
        <div key={i}>
          <div className="rail-section">{s.section}{s.num && <span className="num">{s.num}</span>}</div>
          <nav>
            {s.items.map((it) => {
              const Icon = I[it.icon];
              return (
                <a
                  key={it.route}
                  className={`nav-item${route===it.route?" active":""}`}
                  href={`#${it.route}`}
                  onClick={(e) => { e.preventDefault(); onRoute(it.route); }}
                >
                  <Icon/>
                  <span>{it.label}</span>
                  {it.badge && <span className="badge">{it.badge}</span>}
                </a>
              );
            })}
          </nav>
        </div>
      ))}
      <div className="rail-foot">
        <div className="stat">Tonight<b>3 doors open</b></div>
        <div className="stat" style={{textAlign:"right"}}>Sync<b style={{color:"var(--good)"}}>02:14 ago</b></div>
      </div>
    </aside>
  );
}
